export default {
  data() {
    return {
      filterOption: {
        categoryType: "allow",
        eventType: "allow",
        operation: "union"
      },
      queryParam: {
        categorys: [],
        events: []
      }
    };
  },
  computed: {
    filteredCategorys() {
      return this.categorysArray.filter(
        o => !this.queryParam.categorys.includes(o.name)
      );
    },
    filteredEvents() {
      return this.eventsArray.filter(
        o => !this.queryParam.events.includes(o.name)
      );
    },
    categorysArray() {
      const result = [];
      for (let key in this.categorys) {
        if (this.categorys[key].active) result.push(this.categorys[key]);
      }

      return result;
    },
    eventsArray() {
      const result = [];
      for (let key in this.events) {
        if (this.events[key].active) result.push(this.events[key]);
      }

      return result;
    }
  },
  methods: {
    filterCategorys(selectedItems) {
      this.queryParam.categorys = selectedItems;
    },
    filterEvents(selectedItems) {
      this.queryParam.events = selectedItems;
    },
    handleSearch() {
      // console.log("search", value);
    }
  }
};
